import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTextAlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.75 5.75h9.5M9.75 18.25h9.5M4.75 12h14.5"
    />
  </svg>
);
export default SvgTextAlignRight;
